<template>
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="8" fill="#E9EBED"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5006 31L12.5512 21.8537C10.9396 20.2754 10.5399 17.8638 11.5589 15.867V15.867C12.3203 14.3758 13.767 13.334 15.4471 13.067C17.1272 12.8001 18.8358 13.3405 20.0393 14.5195L21.5006 15.9511L22.9618 14.5195C24.165 13.3405 25.8734 12.8 27.5533 13.067C29.2331 13.334 30.6795 14.3758 31.4405 15.867V15.867C32.46 17.8635 32.061 20.275 30.45 21.8537L21.5006 31Z" stroke="#181F36" stroke-opacity="0.1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name:"HeartDisabledIcon"
}
</script>